import { mapPlatformIdsToMediaPerson } from '../utils';
import { Platform } from '../types';

export const SPOTIFY_AUTH_TOKEN_KEY = 'spotifyAuthToken';
export const SPOTIFY_ARTISTS_CONFIG = mapPlatformIdsToMediaPerson(
  Platform.Spotify,
);
